// components/NotFound.js (or pages/NotFound.js)
import React from 'react';
import { Link } from 'react-router-dom';

const colors = {
  mainBlue: "#061941",
  xanthous: "#F2AF29",
  isabelline: "#F4F3EE",
  carrieban: "#3C6E71",
  cafeNoir: "#583E23",
};

function NotFound() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '2rem',
      textAlign: 'center',
      fontFamily: 'Nunito, Segoe UI, Arial, sans-serif'
    }}>
      <h1 style={{
        fontSize: '4rem',
        fontWeight: 800,
        color: colors.mainBlue,
        margin: '0 0 1rem 0'
      }}>
        404
      </h1>
      <h2 style={{
        fontSize: '2rem',
        fontWeight: 700,
        color: colors.mainBlue,
        margin: '0 0 1rem 0'
      }}>
        Page Not Found
      </h2>
      <p style={{
        fontSize: '1.2rem',
        color: colors.cafeNoir,
        marginBottom: '2rem',
        maxWidth: '500px'
      }}>
        Sorry, we couldn't find the page you're looking for. The page may have been moved or doesn't exist.
      </p>
      <Link
        to="/"
        style={{
          backgroundColor: colors.xanthous,
          color: colors.mainBlue,
          padding: '12px 24px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontWeight: 700,
          fontSize: '1rem',
          transition: 'background-color 0.15s'
        }}
        onMouseOver={e => e.currentTarget.style.backgroundColor = '#E09A1F'}
        onMouseOut={e => e.currentTarget.style.backgroundColor = colors.xanthous}
      >
        Go Back Home
      </Link>
    </div>
  );
}

export default NotFound;